module.exports = __webpack_public_path__ + "media/images/icons/favicon-4d4e680df642ffd3236ff158eecc817a.ico";